import { useFilteredJobStore } from '@/components/jobs/job-search-page/filteredJobStore'
import { storeToRefs } from 'pinia'
import { FiltersTopBarStore } from '@/components/filters/FiltersTopBarStore'
import { useFilteredBatchStore } from '@/components/batches/useFilteredBatchStore'
import { FiltersTopBarEntity } from '@/components/filters/useFilterContextBridge'

export function useFilteredStore(entityType: FiltersTopBarEntity): FiltersTopBarStore {
  const store = entityType === 'Job' ? useFilteredJobStore() : useFilteredBatchStore()
  return {
    ...storeToRefs(store),
    setFilter: store.setFilter,
    removeFilter: store.removeFilter,
    setPendingFilter: store.setPendingFilter,
  }
}
